import React, { memo } from 'react'
import { Tag, ITagProps, TAG_SIZE } from 'transfix-ui/components/Tag'
import makeStyles from 'transfix-ui/core/styles/makeStyles'
import { brandColors } from 'transfix-ui/theme'
import {
  ICarrierCallListMatchStrategyEnum,
  ILaneCarrierMatchListFilterEnum,
} from 'types/graphqlTypes'
import { getMatchStrategyLabel, getMatchStyle } from '../utils'

export interface ICarrierListItemTagProps extends Omit<ITagProps, 'tagStyle' | 'label'> {
  /**
   * @example 'Posted Trucks'
   */
  matchType: ICarrierCallListMatchStrategyEnum | ILaneCarrierMatchListFilterEnum
  /**
   * Optionally included date of last update
   * @example '2021-12-16T11:30:00Z'
   */
  datetime?: string | null
}

const useCarrierListItemTagStyles = makeStyles({
  root: {
    '& > span': {
      color: brandColors.white,
    },
  },
})

export const CarrierListItemTag = memo<ICarrierListItemTagProps>(
  ({
    matchType,
    dataTest = 'carrier-list-item-tag',
    size = TAG_SIZE.xsmall,
    datetime,
    ...rest
  }) => {
    const classes = useCarrierListItemTagStyles()

    // cast as ICarrierCallListMatchStrategyEnum since ILaneCarrierMatchListFilter enum is a subset
    const label = getMatchStrategyLabel(matchType as ICarrierCallListMatchStrategyEnum, datetime)
    const tagStyle = getMatchStyle(matchType as ICarrierCallListMatchStrategyEnum)

    return (
      <Tag
        {...rest}
        dataTest={dataTest}
        className={classes.root}
        tagStyle={tagStyle}
        label={label}
        size={size}
      />
    )
  }
)
